import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    LOADING_WATCHLIST_SUCCESS,
    LOADING_WATCHLIST_FAIL,
    REGISTER_SUCCESS,
    REGISTER_FAIL,
} from '../actions/types';

// For Firebase-only auth, we don't use access_token/refresh_token from backend
const initialState = {
    isAuthenticated: localStorage.getItem('user') ? true : false,
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
    watchlistData: (() => {
        const stored = localStorage.getItem('watchlist-data');
        if (stored) {
            try {
                const parsed = JSON.parse(stored)['data'];
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    })(),
    publicKey: localStorage.getItem('public-key') ? JSON.parse(localStorage.getItem('public-key')) : null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case AUTHENTICATED_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
            }
        case LOGIN_SUCCESS:
            if (payload.user) {
                localStorage.setItem('user', JSON.stringify(payload.user));
            }
            return {
                ...state,
                isAuthenticated: true,
                user: payload.user,
            }
        case REGISTER_SUCCESS:
            return {
                ...state,
                isRegistered: true,
                user: payload.user,
            }
        case REGISTER_FAIL:
            return {
                ...state,
                isRegistered: false,
            }
        case AUTHENTICATED_FAIL:
            return {
                ...state,
                isAuthenticated: false
            }
        case LOGIN_FAIL:
        case LOGOUT:
            localStorage.removeItem('user');
            return {
                ...state,
                isAuthenticated: false,
                user: null
            }
        case USER_LOADED_SUCCESS:
            return {
                ...state,
                user: payload
            }
        case USER_LOADED_FAIL:
            return {
                ...state,
                user: null,
                isAuthenticated: false
            }
        case LOADING_WATCHLIST_SUCCESS:
            localStorage.setItem('watchlist-data', JSON.stringify({'data': payload}));
            return {
                ...state,
                watchlistData: payload,
            }
        case LOADING_WATCHLIST_FAIL:
            return {
                ...state,
            }
        // case LOADING_PUBLIC_KEY_SUCCESS:
        //     localStorage.setItem('public-key', JSON.stringify(payload));
        //     return {
        //         ...state,
        //         publicKey: payload,
        //     }
        // case LOADING_PUBLIC_KEY_FAIL:
        //     return {
        //         ...state,
        //     }
        default:
            return state
    }
}